import React, { useContext } from "react";
import { Grid, Typography, Button, IconButton } from "@mui/material";
import { ThemeContext } from "../../../context/ThemeContext";
import { Facebook, Twitter, YouTube, LinkedIn } from "@mui/icons-material";
import { useTranslation } from "react-i18next";


const CompanyDetail = ({ onBackToLogin, companyData }) => {
 const {t} = useTranslation()
    const { darkMode } = useContext(ThemeContext)


    return (
        <>

            <Grid container sx={{ padding: "10px" }}>
                <Grid item xs={12}><Typography variant="body2" sx={{ color: darkMode ? "var(--lightText)" : "var(--black)", marginBottom: '15px' }}>{t('companyInformation')}</Typography></Grid>
                <Grid container spacing={2} sx={{ marginBottom: '15px' }}>
                    <Grid item xs={4}><Typography variant="body2" className="text-gray1">{t('company')}</Typography></Grid>
                    <Grid item xs={8}><Typography variant="body2" sx={{ color: darkMode ? "var(--lightText)" : "var(--black)" }}>{companyData?.companyName}</Typography></Grid>
                    <Grid item xs={4}><Typography variant="body2" className="text-gray1">{t('registrationAddress')}</Typography></Grid>
                    <Grid item xs={8}><Typography variant="body2" sx={{ color: darkMode ? "var(--lightText)" : "var(--black)" }}>{companyData?.address}</Typography></Grid>
                    <Grid item xs={4}><Typography variant="body2" className="text-gray1">{t('website')}</Typography></Grid>
                    <Grid item xs={8}><Typography variant="body2" className="text-primary"> <a href={companyData?.websiteUrl} target="_blank" rel="noopener noreferrer">{companyData?.websiteUrl}</a></Typography></Grid>
                    <Grid item xs={4}><Typography variant="body2" className="text-gray1">{t('email')}</Typography></Grid>
                    <Grid item xs={8}><Typography variant="body2" className="text-primary">{companyData?.email}</Typography></Grid>
                    {/* <Grid item xs={12}><Typography variant="body2" sx={{color:'red'}}>{error}</Typography></Grid> */}

                </Grid>
                <Grid item xs={4}><Typography variant="body2" className="text-gray1">{t('followUs')}</Typography></Grid>
                <Grid item xs={8}>
                    <IconButton component="a" href={companyData?.facebookUrl} target="_blank" rel="noopener noreferrer"><Facebook sx={{ color: "#1877F2" }} /></IconButton>
                    <IconButton component="a" href={companyData?.xUrl} target="_blank" rel="noopener noreferrer"> <Twitter sx={{ color: "#1DA1F2" }} /> </IconButton>
                    <IconButton component="a" href={companyData?.youTubeUrl} target="_blank" rel="noopener noreferrer"> <YouTube sx={{ color: "#FF0000" }} /> </IconButton>
                    <IconButton component="a" href={companyData?.linkedInUrl} target="_blank" rel="noopener noreferrer"> <LinkedIn sx={{ color: "#0077B5" }} /> </IconButton>
                </Grid>
                <Grid container justifyContent="flex-end">
                    <Button variant="contained" color="secondary" onClick={onBackToLogin} sx={{ border: '1px solid green', marginTop: "20px", color: "white", padding: '5px', pl: 2, pr: 2, textTransform: "none", }}>{t('backToLogin')}</Button>
                </Grid>
            </Grid>
        </>
    );
};

export default CompanyDetail;
